/** @format */

import * as React from 'react'
import { getDisplayName } from './getDisplayName'

export function Props(value) {
  if (!(this instanceof Props)) return new Props(value)
  this.value = typeof value === 'function' ? value : () => value
}

export function Component(value) {
  if (!(this instanceof Component)) return new Component(value)
  this.value = typeof value === 'function' ? value : () => value
}

const noop = () => Props({})

const storesToState = stores =>
  Object.keys(stores).reduce(
    (acc, key) => ({ ...acc, [key]: stores[key].getState() }),
    {},
  )

export const multiConnect = (stores, mapState = noop) => Comp =>
  class extends React.Component {
    static displayName = `@multiConnect(${getDisplayName(Comp)})`

    componentDidMount() {
      this.mount = true
      this.subs = Object.keys(stores).map(key =>
        stores[key].subscribe(_ => this.mount && this.forceUpdate()),
      )
    }

    componentWillUnmount() {
      this.mount = false
      this.subs.forEach(unsubscribe => unsubscribe())
    }

    render() {
      const maybe = mapState(storesToState(stores), this.props)
      if (maybe instanceof Component) return maybe.value()
      if (maybe instanceof Props)
        return <Comp {...this.props} {...maybe.value()} />
      return null
    }
  }
